import type { ListParams } from '../type';
import baseKey from './_baseKey';

const templateDomainKey = () => baseKey.domainKey('template');

/**
 * 작업 템플릿 관련 쿼리키 제너레이터
 */
const templateKey = {
  /**
   * @returns 작업 템플릿 도메인 기본 쿼리키 (getter)
   * @example ['template']
   */
  domain() {
    return templateDomainKey();
  },
  /**
   * @param id 작업 템플릿 리스트 아이템 ID
   * @returns 작업 템플릿 상세 데이터 요청 쿼리키
   * @example ['template', 'detail', 1]
   */
  detailById(id: number) {
    return [...baseKey.itemKey(templateDomainKey(), 'detail'), id];
  },
};

export default Object.freeze(templateKey);
